import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RESET_STATE } from "@redux-offline/redux-offline/lib/constants";

interface CameraModal {
  show: boolean;
  tag: boolean;
  taskID: boolean;
}

interface PhotosModal {
  show: boolean;
  tag: boolean;
  taskID: boolean;
}

interface NotesModal {
  show: boolean;
  canAssignTask: boolean;
}

interface TimesheetFieldModal {
  show: boolean;
  taskID: boolean;
}

interface Tab {
  key: number;
  value: string;
}

interface AppState {
  isReady: boolean;
  jobsPage: number;
  helpModal: boolean;
  cameraModal: CameraModal;
  photosModal: PhotosModal;
  notesModal: NotesModal;
  timesheetFieldModal: TimesheetFieldModal;
  tab: Tab;
}

const initialState: AppState = {
  isReady: false,
  jobsPage: 0,
  helpModal: false,
  cameraModal: {
    show: false,
    tag: false,
    taskID: false,
  },
  photosModal: {
    show: false,
    tag: false,
    taskID: false,
  },
  notesModal: {
    show: false,
    canAssignTask: false,
  },
  timesheetFieldModal: {
    show: false,
    taskID: false,
  },
  tab: { key: 0, value: "info" }
};

const appStateSlice = createSlice({
  name: 'appState',
  initialState,
  reducers: {
    setIsReady: (state, action: PayloadAction<boolean>) => {
      state.isReady = action.payload;
    },
    updateJobsPage: (state, action: PayloadAction<number>) => {
      state.jobsPage = action.payload;
    },
    updateTab: (state, action: PayloadAction<Tab>) => {
      state.tab = action.payload;
    },
    updateHelpModal: (state, action: PayloadAction<boolean>) => {
      state.helpModal = action.payload;
    },
    updateCameraModal: (state, action: PayloadAction<CameraModal>) => {
      state.cameraModal = action.payload;
    },
    updatePhotosModal: (state, action: PayloadAction<PhotosModal>) => {
      state.photosModal = action.payload;
    },
    updateNotesModal: (state, action: PayloadAction<NotesModal>) => {
      state.notesModal = action.payload;
    },
    updateTimesheetFieldModal: (state, action: PayloadAction<TimesheetFieldModal>) => {
      state.timesheetFieldModal = action.payload;
    },
    restartQueue: (state, action: PayloadAction<{ delay?: number }>) => {
      // This action is handled by Redux Offline
    },
  },
  extraReducers: (builder) => {
    builder.addCase(RESET_STATE, () => initialState);
  }
});

export const {
  setIsReady,
  updateJobsPage,
  updateTab,
  updateHelpModal,
  updateCameraModal,
  updatePhotosModal,
  updateNotesModal,
  updateTimesheetFieldModal,
  restartQueue,
} = appStateSlice.actions;

// Export legacy action names for compatibility
export const isReady = setIsReady;
export const deleteOfflineQueue = () => ({ type: RESET_STATE });

export default appStateSlice.reducer;